/**
 * PRODUCTS JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_sliders from './aon_craft_sliders.js';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise SECTION 3C UI, data
         * UI interaction functions
         */
        console.log( 'SECTION 3C - init' );
        
        // Variable to contain products entries
        this.aon_section_3c_data = []; 
        
    
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 3C...
            if ( $( '#section_3c_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Render Products...
        this.renderProducts();
        
        /*
         * Add / Edit Modal interaction...
         */
        
        var products_add_edit_modal_mode = '';
        
        // Click to Edit existing Products entry modal link...
        $( 'body' ).on( 'click', '.products_entry a.edit', function( event ) {
            products_add_edit_modal_mode = 'edit';
            //var name = $( this ).text();
            var name = $( this ).attr( 'title' );
            var description = $( this ).attr( 'data-products-entry-description' );
            var product_number = $( this ).attr( 'data-products-entry-product-number' );
            var id = $( this ).attr( 'data-products-entry-id' );
            $( '#products_add_edit_entry_modal #products_entry_title_field' ).val( name );
            $( '#products_add_edit_entry_modal #products_entry_description_field' ).val( description );
            $( '#products_add_edit_entry_modal #products_entry_id' ).val( id );
            $( '#products_add_edit_entry_modal #products_entry_product_number' ).val( product_number );
            
            console.log( 'Start opening Products Modal...');
            openProductsModal();
            console.log( 'Done opening Products Modal...');
            
            event.preventDefault();
        });
		
		// Product entry hover / highlighting...
        $( 'body' ).on( 'mouseenter', '.products_entry a.edit', function() {
			$( this ).find( $( '.product-entry-edit-tooltip' ) ).remove();
			var edit_tooltip = $( '.product-entry-edit-tooltip.hide' ).clone();
			edit_tooltip.removeClass( 'hide' );
			$( this ).append( edit_tooltip );
        });

        $( 'body' ).on( 'mouseleave', '.products_entry a.edit', function() {
			$( this ).find( $( '.product-entry-edit-tooltip' ) ).remove();
        });
        
        var openProductsModal = () => { // Function defined using arrow method to gain access to main 'this'
            // Open specific modal depending on whether we're adding / editing entries or setting activity types
            console.log( 'Called opening Products Modal...');
            $( '#products_add_edit_entry_modal' ).foundation( 'open' );
        }
        

        // Click on Add Product entry modal link...
        $( 'body' ).on( 'click', '.products_entry a.add', function( event ) {
            products_add_edit_modal_mode = 'add';
            var product_number = $( this ).attr( 'data-products-entry-product-number' );
            $( '#products_add_edit_entry_modal #products_entry_product_number' ).val( product_number );
            event.preventDefault();
        });

        // 'Save' button click within Products entry modal...
        $( 'body' ).on( 'click', '#save_products_entry', function( event ) {
            // Save data to existing
            var id = aon_craft_utils.removeHTMLTags( $( '#products_add_edit_entry_modal #products_entry_id' ).val() );
            var name = aon_craft_utils.removeHTMLTags( $( '#products_add_edit_entry_modal #products_entry_title_field' ).val() );
            var description = aon_craft_utils.removeHTMLTags( $( '#products_add_edit_entry_modal #products_entry_description_field' ).val() );
            var product_number = aon_craft_utils.removeHTMLTags( $( '#products_add_edit_entry_modal #products_entry_product_number' ).val() );
            if ( products_add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && name != '' && description != '' ) {
                    saveExistingProductsEntry( id, name, description, product_number );
                }
            } else if ( products_add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( name != '' && description != '' && product_number != '' ) {
                    saveNewProductsEntry( name, description, product_number );
                }
            } else if ( products_add_edit_modal_mode == 'delete' ) {
                // Delete...
                deletingExistingProductsEntry( id );
            }
            
            event.preventDefault();
        });

        
        var saveExistingProductsEntry = ( id, name, description, product_number ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_3c_data[ id ][ 'name' ] = name;
            this.aon_section_3c_data[ id ][ 'description' ] = description;
            this.aon_section_3c_data[ id ][ 'product_number' ] = product_number;
            this.renderProductEntries();
            $( '#products_add_edit_entry_modal' ).foundation( 'close' );
            //console.log( 'SAVE TASK' );
        }
        
        var saveNewProductsEntry = ( name, description, product_number ) => { // Function defined using arrow method to gain access to main 'this'
            //var new_entry = { name: name, start_month: start_month, duration: duration, activity_type: '' }
            this.aon_section_3c_data.push( { name: name, description: description, product_number: product_number } );
            this.renderProductEntries();
            $( '#products_add_edit_entry_modal' ).foundation( 'close' );
        }
        
        var deletingExistingProductsEntry = ( id ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_3c_data[ id ][ 'name' ] = name;
            this.aon_section_3c_data.splice( id, 1 );
            this.renderProductEntries();
            $( '#products_add_edit_entry_modal' ).foundation( 'close' );
            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_products_entry ').text( save_text ); // Save
            $( '#save_products_entry ').removeClass( 'delete' );            
        }
       
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#products_add_edit_entry_modal', function() {
            if ( products_add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
                $( '#save_entry ').text( save_text ); // Save
                $( '#save_entry ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
                
            } else if ( products_add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                $( '#products_entry_title_field' ).val( '' );
                $( '#products_entry_description_field' ).val( '' );
                
            }
            $( '#products_entry_title_field' ).focus();
            console.log( 'products_add_edit_entry_modal open' );
        });
        

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#products_add_edit_entry_modal', function() {
            $( '#products_entry_title_field' ).val( '' );
            $( '#products_entry_description_field' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_products_entry ').text( save_text ); // Save
            $( '#save_products_entry ').removeClass( 'delete' );
            console.log( 'products_add_edit_entry_modal close' );
        });
        

        
        /*
         * MODAL Delete / Normal button states
         */
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_text' ).val();
				var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_products_entry ').text( delete_text ); // DELETE
                $( '#save_products_entry ').addClass( 'delete' );
                products_add_edit_modal_mode = 'delete';
                console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_products_entry ').text( save_text ); // Save
                $( '#save_products_entry ').removeClass( 'delete' );
                products_add_edit_modal_mode = 'edit';
                console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        
        // Check Product 1 fields are complete before enabling 'Next' button...
        $( 'body' ).on( 'keyup', '.product_page_1 textarea', function( event ) {
            var product_features_1 = $( '.product_page_1 #product_features_1' ).val();
            var customer_benefits_1 = $( '.product_page_1 #customer_benefits_1' ).val();
            var maker_benefits_1 = $( '.product_page_1 #maker_benefits_1' ).val();
            if ( product_features_1 == '' || customer_benefits_1 == '' || maker_benefits_1 == '' ) {
                $( '.product_1_next' ).addClass( 'disabled' );
            } else {
                $( '.product_1_next' ).removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        // Check Product 2 fields are complete before enabling 'Next' button...
        $( 'body' ).on( 'keyup', '.product_page_2 textarea', function( event ) {
            var product_features_2 = $( '.product_page_2 #product_features_2' ).val();
            var customer_benefits_2 = $( '.product_page_2 #customer_benefits_2' ).val();
            var maker_benefits_2 = $( '.product_page_2 #maker_benefits_2' ).val();
            if ( product_features_2 == '' || customer_benefits_2 == '' || maker_benefits_2 == '' ) {
                $( '.product_2_next' ).addClass( 'disabled' );
            } else {
                $( '.product_2_next' ).removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        // Check Product 3 fields are complete before enabling 'Next' button...
        $( 'body' ).on( 'keyup', '.product_page_3 textarea', function( event ) {
            var product_features_3 = $( '.product_page_3 #product_features_3' ).val();
            var customer_benefits_3 = $( '.product_page_3 #customer_benefits_3' ).val();
            var maker_benefits_3 = $( '.product_page_3 #maker_benefits_3' ).val();
            if ( product_features_3 == '' || customer_benefits_3 == '' || maker_benefits_3 == '' ) {
                $( '.product_3_next' ).addClass( 'disabled' );
            } else {
                $( '.product_3_next' ).removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        // FEATURES, BENEFITS...
        $( 'body' ).on( 'click', '.product_1_next', function( event ) {
            // Save Product 1 details to array...
			var product_features_1_index = aon_craft_utils.removeHTMLTags( $( '.product_page_1 #product_features_1_index' ).val() );
			
            var features1 = aon_craft_utils.removeHTMLTags( $( '.product_page_1 #product_features_1' ).val() );
            $( '.product_page_1 #product_features_1' ).val( features1 );
			
            var customer_benefits1 = aon_craft_utils.removeHTMLTags( $( '.product_page_1 #customer_benefits_1' ).val() );
            $( '.product_page_1 #customer_benefits_1' ).val( customer_benefits1 );
			
            var maker_benefits1 = aon_craft_utils.removeHTMLTags( $( '.product_page_1 #maker_benefits_1' ).val() );
            $( '.product_page_1 #maker_benefits_1' ).val( maker_benefits1 );
			
            saveProductFeaturesBenefits( product_features_1_index, features1, customer_benefits1, maker_benefits1 );
        });
        
        $( 'body' ).on( 'click', '.product_2_next', function( event ) {
            // Save Product 2 details to array...
			var product_features_2_index = aon_craft_utils.removeHTMLTags( $( '.product_page_2 #product_features_2_index' ).val() );
			
            var features2 = aon_craft_utils.removeHTMLTags( $( '.product_page_2 #product_features_2' ).val() );
            $( '.product_page_2 #product_features_2' ).val( features2 );
			
            var customer_benefits2 = aon_craft_utils.removeHTMLTags( $( '.product_page_2 #customer_benefits_2' ).val() );
            $( '.product_page_2 #customer_benefits_2' ).val( customer_benefits2 );
			
            var maker_benefits2 = aon_craft_utils.removeHTMLTags( $( '.product_page_2 #maker_benefits_2' ).val() );
            $( '.product_page_2 #maker_benefits_2' ).val( maker_benefits2 );
			
            saveProductFeaturesBenefits( product_features_2_index, features2, customer_benefits2, maker_benefits2 );
        });
        
        $( 'body' ).on( 'click', '.product_3_next', function( event ) {
            // Save Product 3 details to array...
			var product_features_3_index = aon_craft_utils.removeHTMLTags( $( '.product_page_3 #product_features_3_index' ).val() );
			
            var features3 = aon_craft_utils.removeHTMLTags( $( '.product_page_3 #product_features_3' ).val() );
            $( '.product_page_3 #product_features_3' ).val( features3 );
			
            var customer_benefits3 = aon_craft_utils.removeHTMLTags( $( '.product_page_3 #customer_benefits_3' ).val() );
            $( '.product_page_3 #customer_benefits_3' ).val( customer_benefits3 );
			
            var maker_benefits3 = aon_craft_utils.removeHTMLTags( $( '.product_page_3 #maker_benefits_3' ).val() );
            $( '.product_page_3 #maker_benefits_3' ).val( maker_benefits3 );
			
            saveProductFeaturesBenefits( product_features_3_index, features3, customer_benefits3, maker_benefits3 );
        });
        
        var saveProductFeaturesBenefits = ( id, features, customer_benefits, maker_benefits ) => {
            this.aon_section_3c_data[ id ][ 'features' ] = features;
            this.aon_section_3c_data[ id ][ 'customer_benefits' ] = customer_benefits;
            this.aon_section_3c_data[ id ][ 'maker_benefits' ] = maker_benefits;
            this.renderProductEntries();
        }
        
        /*var saveProductFeaturesBenefits1 = ( id1, features1, customer_benefits1, maker_benefits1 ) => {
            this.aon_section_3c_data[ id1 ][ 'features' ] = features1;
            this.aon_section_3c_data[ id1 ][ 'customer_benefits' ] = customer_benefits1;
            this.aon_section_3c_data[ id1 ][ 'maker_benefits' ] = maker_benefits1;
            this.renderProductEntries();
        }
        
        var saveProductFeaturesBenefits2 = ( id2, features2, customer_benefits2, maker_benefits2 ) => {
            this.aon_section_3c_data[ id2 ][ 'features' ] = features2;
            this.aon_section_3c_data[ id2 ][ 'customer_benefits' ] = customer_benefits2;
            this.aon_section_3c_data[ id2 ][ 'maker_benefits' ] = maker_benefits2;
            this.renderProductEntries();
        }
        
        var saveProductFeaturesBenefits3 = ( id3, features3, customer_benefits3, maker_benefits3 ) => {
            this.aon_section_3c_data[ id3 ][ 'features' ] = features3;
            this.aon_section_3c_data[ id3 ][ 'customer_benefits' ] = customer_benefits3;
            this.aon_section_3c_data[ id3 ][ 'maker_benefits' ] = maker_benefits3;
            this.renderProductEntries();
        }*/
        
        
        // MARKETS...
        $( 'body' ).on( 'click', '.product_market_1_next', function( event ) {
            // Save Product 1 Markets to array...
			var product_features_1_index = $( '.product_page_1 #product_features_1_index' ).val();
            var markets = getSelectedMarkets( 1 );
            var explanation = aon_craft_utils.removeHTMLTags( $( '.product_markets_page_1 #markets_explanation_1' ).val() );
            $( '.product_markets_page_1 #markets_explanation_1' ).val( explanation );
            saveProductMarketsExplanation( product_features_1_index, markets, explanation );
        });
        
        $( 'body' ).on( 'click', '.product_market_2_next', function( event ) {
            // Save Product 2 Markets to array...
			var product_features_2_index = $( '.product_page_2 #product_features_2_index' ).val();
            var markets = getSelectedMarkets( 2 );
            var explanation = aon_craft_utils.removeHTMLTags( $( '.product_markets_page_2 #markets_explanation_2' ).val() );
            $( '.product_markets_page_2 #markets_explanation_2' ).val( explanation );
            saveProductMarketsExplanation( product_features_2_index, markets, explanation );
        });
        
        $( 'body' ).on( 'click', '.product_market_3_next', function( event ) {
            // Save Product 3 Markets to array...
			var product_features_3_index = $( '.product_page_3 #product_features_3_index' ).val();
            var markets = getSelectedMarkets( 3 );
            var explanation = aon_craft_utils.removeHTMLTags( $( '.product_markets_page_3 #markets_explanation_3' ).val() );
            $( '.product_markets_page_3 #markets_explanation_3' ).val( explanation );
            saveProductMarketsExplanation( product_features_3_index, markets, explanation );
        });
        
        var saveProductMarketsExplanation = ( id, markets, explanation ) => {
			//console.log( 'saveProductMarketsExplanation ID: ' + id );
            this.aon_section_3c_data[ id ][ 'markets' ] = markets;
            this.aon_section_3c_data[ id ][ 'markets_explanation' ] = explanation;
            this.renderProductEntries();
        }
        
        function getSelectedMarkets( id ) {
            var markets = '';
            $( '.product_markets_page_' + id + ' .product_market_picker li a.checked' ).each(function( index ) {
                markets += $( this ).text() + ',';
            });
            console.log( 'markets: ' + markets );
            
            return markets;
        }
        
        
        // Check Markets and Explanation field are set before enabling 'Next' button for Product 1 Markets page...
        $( 'body' ).on( 'keyup', '.product_markets_page textarea', function( event ) {
            var id = $( this ).attr( 'id' );
            if ( id == 'markets_explanation_1' ) {
                var markets_explanation = $( '.product_markets_page_1 #markets_explanation_1' ).val();
                var markets = getSelectedMarkets( 1 );
                var product_market_next = $( '.product_market_1_next' );
                
            } else if ( id == 'markets_explanation_2' ) {
                var markets_explanation = $( '.product_markets_page_2 #markets_explanation_2' ).val();
                var markets = getSelectedMarkets( 2 );
                var product_market_next = $( '.product_market_2_next' );
                
            } else if ( id == 'markets_explanation_3' ) {
                var markets_explanation = $( '.product_markets_page_3 #markets_explanation_3' ).val();
                var markets = getSelectedMarkets( 3 );
                var product_market_next = $( '.product_market_3_next' );
            }
            
            if ( markets_explanation == '' || markets == '' ) {
                product_market_next.addClass( 'disabled' );
            } else {
                product_market_next.removeClass( 'disabled' );
            }
            event.preventDefault();
        });
        
        
        
        
        // Check / Uncheck Product Market buttons.. 
        $( 'body' ).on( 'click', '.product_market_picker a', function( event ) {
            if ( $( this ).hasClass( 'checked' ) ) {
                $( this ).removeClass( 'checked' );
                
            } else {
                $( this ).addClass( 'checked' );
            }
            
            var id = $( this ).parents( '.product_market_picker' ).attr( 'data-product-id' );
            
            if ( id == 1 ) {
                var markets_explanation = $( '.product_markets_page_1 #markets_explanation_1' ).val();
                var markets = getSelectedMarkets( 1 );
                var product_market_next = $( '.product_market_1_next' );
                
            } else if ( id == 2 ) {
                var markets_explanation = $( '.product_markets_page_2 #markets_explanation_2' ).val();
                var markets = getSelectedMarkets( 2 );
                var product_market_next = $( '.product_market_2_next' );
                
            } else if ( id == 3 ) {
                var markets_explanation = $( '.product_markets_page_3 #markets_explanation_3' ).val();
                var markets = getSelectedMarkets( 3 );
                var product_market_next = $( '.product_market_3_next' );
            }
            
            if ( markets_explanation == '' || markets == '' ) {
                product_market_next.addClass( 'disabled' );
            } else {
                product_market_next.removeClass( 'disabled' );
            }
            
            event.preventDefault();
      
        });
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        

    },
    
    renderProducts() {
        // Render Products...
        console.log( 'renderProducts - start' );
        
        // Render entries...
        this.renderProductEntries();
        
        /*if ( this.aon_section_3c_data === '' ) {
            $( '.products_entry_add_edit' ).addClass( 'no_entries' );
        }*/
    },
    
    renderProductEntries() {
        /*
         * Load / render existing entries to calendar...
         */
        console.log( 'renderProductEntries - start' );
        console.table( this.aon_section_3c_data );  
        
        // Remove any existing entries so that we don't re-render...
        $( '.products .products_entry_1 a.edit, .products .products_entry_2 a.edit, .products .products_entry_3 a.edit' ).remove();
        $( '.products .products_entry_1 a.add, .products .products_entry_2 a.add, .products .products_entry_3 a.add' ).show();
        $( '.product_page_1 .name h4' ).text( '' );
        $( '.product_markets_page_2 .name h4' ).text( '' );
        $( '.product_page_1 .description p' ).text( '' );
        $( '.product_page_2 .name h4' ).text( '' );
        $( '.product_markets_page_2 .name h4' ).text( '' );
        $( '.product_page_2 .description p' ).text( '' );
        $( '.product_page_3 .name h4' ).text( '' );
        $( '.product_markets_page_3 .name h4' ).text( '' );
        $( '.product_page_3 .description p' ).text( '' );
   
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_section_3c_data, function( index ) {
            // Begin entry...           
            var aon_products_entry_link = '<a href="#edit_products_entry" data-products-entry-id="' + index + '" data-products-entry-description="' + this.description + '" data-products-entry-product-number="' + this.product_number + '" class="edit" title="' + this.name + '">' + this.product_number + '. ' + this.name + '</a>';
            //var aon_products_entry_link = '<a href="#edit_products_entry" data-products-entry-id="' + index + '" data-products-entry-description="' + this.description + '" data-products-entry-product-number="' + this.product_number + '" class="edit entry_' + entry_count + ' " title="' + this.name + '">' + this.product_number + '. ' + this.name + '</a>';
            console.log( 'this.product_number: ' + this.product_number );
            
            if ( this.product_number == 1 ) {
                $( '.products .products_entry_1 a.add' ).hide();
                $( '.products .products_entry_1 a.edit' ).remove();
                $( '.products .products_entry_1' ).append( '' + aon_products_entry_link + '' );
                $( '.product_page_1 .name h4' ).text( this.name );
                $( '.product_markets_page_1 .name h4' ).text( this.name );
                $( '.product_page_1 .description p' ).text( this.description );
                
                $( '.product_page_1 #product_features_1' ).val( this.features );
                $( '.product_page_1 #customer_benefits_1' ).val( this.customer_benefits );
                $( '.product_page_1 #maker_benefits_1' ).val( this.maker_benefits );
				
                $( '.product_page_1 #product_features_1_index' ).val( index );
                
                if ( this.features == '' || this.customer_benefits == '' || this.maker_benefits == '' ) {
                    $( '.product_1_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_1_next' ).removeClass( 'disabled' );
                }
                
                $( '.product_markets_page_1 #markets_explanation_1' ).val( this.markets_explanation );
                
				//console.log( 'this.markets: -- ' + this.markets + ' --' );
                if ( this.markets ) {
                    var markets_arr = this.markets.toLowerCase().split( ',' );
                    $.each( markets_arr, function( index, value ) {
                        if ( value == 'local' ) {
                            $('.product_markets_page_1 .product_market_picker a[data-product-market-entry-id="1"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'national' ) {
                            $('.product_markets_page_1 .product_market_picker a[data-product-market-entry-id="2"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'international' ) {
                            $('.product_markets_page_1 .product_market_picker a[data-product-market-entry-id="3"]' ).addClass( 'checked' );
                        }
                    });
                }
                
                if ( this.markets_explanation == '' || this.markets == '' ) {
                    $( '.product_market_1_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_market_1_next' ).removeClass( 'disabled' );
                }
                
            } else if ( this.product_number == 2 ) {
                $( '.products .products_entry_2 a.add' ).hide();
                $( '.products .products_entry_2 a.edit' ).remove();
                $( '.products .products_entry_2' ).append( '' + aon_products_entry_link + '' );
                $( '.product_page_2 .name h4' ).text( this.name );
                $( '.product_markets_page_2 .name h4' ).text( this.name );
                $( '.product_page_2 .description p' ).text( this.description );
                
                $( '.product_page_2 #product_features_2' ).val( this.features );
                $( '.product_page_2 #customer_benefits_2' ).val( this.customer_benefits );
                $( '.product_page_2 #maker_benefits_2' ).val( this.maker_benefits );
                
				$( '.product_page_2 #product_features_2_index' ).val( index );
				
                if ( this.features == '' || this.customer_benefits == '' || this.maker_benefits == '' ) {
                    $( '.product_2_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_2_next' ).removeClass( 'disabled' );
                }
                
                $( '.product_markets_page_2 #markets_explanation_2' ).val( this.markets_explanation );
                
                if ( this.markets ) {
                    var markets_arr = this.markets.toLowerCase().split( ',' );
                    $.each( markets_arr, function( index, value ) {
                        if ( value == 'local' ) {
                            $('.product_markets_page_2 .product_market_picker a[data-product-market-entry-id="1"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'national' ) {
                            $('.product_markets_page_2 .product_market_picker a[data-product-market-entry-id="2"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'international' ) {
                            $('.product_markets_page_2 .product_market_picker a[data-product-market-entry-id="3"]' ).addClass( 'checked' );
                        }
                    });
                }
                
                if ( this.markets_explanation == '' || this.markets == '' ) {
                    $( '.product_market_2_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_market_2_next' ).removeClass( 'disabled' );
                }
                
            } else if ( this.product_number == 3 ) {
                $( '.products .products_entry_3 a.add' ).hide();
                $( '.products .products_entry_3 a.edit' ).remove();
                $( '.products .products_entry_3' ).append( '' + aon_products_entry_link + '' );
                $( '.product_page_3 .name h4' ).text( this.name );
                $( '.product_markets_page_3 .name h4' ).text( this.name );
                $( '.product_page_3 .description p' ).text( this.description );
                
                $( '.product_page_3 #product_features_3' ).val( this.features );
                $( '.product_page_3 #customer_benefits_3' ).val( this.customer_benefits );
                $( '.product_page_3 #maker_benefits_3' ).val( this.maker_benefits );
                
				$( '.product_page_3 #product_features_3_index' ).val( index );
				
                if ( this.features == '' || this.customer_benefits == '' || this.maker_benefits == '' ) {
                    $( '.product_3_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_3_next' ).removeClass( 'disabled' );
                }
                
                $( '.product_markets_page_3 #markets_explanation_3' ).val( this.markets_explanation );
                
                if ( this.markets ) {
                    var markets_arr = this.markets.toLowerCase().split( ',' );
                    $.each( markets_arr, function( index, value ) {
                        if ( value == 'local' ) {
                            $('.product_markets_page_3 .product_market_picker a[data-product-market-entry-id="1"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'national' ) {
                            $('.product_markets_page_3 .product_market_picker a[data-product-market-entry-id="2"]' ).addClass( 'checked' );
                            
                        } else if ( value == 'international' ) {
                            $('.product_markets_page_3 .product_market_picker a[data-product-market-entry-id="3"]' ).addClass( 'checked' );
                        }
                    });
                }
                
                if ( this.markets_explanation == '' || this.markets == '' ) {
                    $( '.product_market_3_next' ).addClass( 'disabled' );
                } else {
                    $( '.product_market_3_next' ).removeClass( 'disabled' );
                }
                
            }
            
            
            
            entry_count++;
            
        });
        
        // If enable / disable Next button depending on whether entries exist...
        //products_add_edit_next
        if ( this.aon_section_3c_data.length === 3 ) {
            $( '.products_add_edit_next' ).removeClass( 'disabled' );
        } else {
            $( '.products_add_edit_next' ).addClass( 'disabled' );
        }
        
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_3c_data_json = $( '#section_3c_data_json' ).val();
            this.aon_section_3c_data = JSON.parse( aon_section_3c_data_json );
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_3c_data_json = '[';
                aon_section_3c_data_json += '{"name":"Cheese slicer", "description":"Nullam quis risus eget urna mollis ornare vel eu leo. Lorem ipsum dolor sit amet, consectetur adipiscing elit.","product_number":"1","features":"","customer_benefits":"","maker_benefits":"","markets":"","markets_explanation":""},';
                aon_section_3c_data_json += '{"name":"Chocolate teapot", "description":"Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.", "product_number":"2","features":"","customer_benefits":"","maker_benefits":"","markets":"","markets_explanation":""}';
                //aon_section_3c_data_json += '{"name":"Thermal glasses", "description":"Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit sit amet non magna.", "product_number":"3","features":"","customer_benefits":"","maker_benefits":"","markets":"","markets_explanation":""}';
                aon_section_3c_data_json += ']';

            this.aon_section_3c_data = JSON.parse( aon_section_3c_data_json );
            $( '.products_add_edit_next' ).removeClass( 'disabled' );
            
        } else if ( mode == 'start' ) {
            //No need for default entry creation as the existing code handles creating entries
            
        }
      
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_section_3c_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '3C AJAX - START' );
        var meta = { 'section_3c_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '3C AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_3c_data );
    },
}